export default function callPhone(callClick: BaseAnyFunction, phone: string) {
  return () => {
    callClick(phone);
  };
}
